<template>
  <header>

    <div class="collapse bg-dark" id="navbarHeader">
      <div class="container">
        <div class="row">
          <div class="col-sm-8 col-md-7 py-4">
            <h4 class="text-white">À propos</h4>
            <p class="text-muted">{{`${totalDatabaseProblems} problèmes de mathématiques pour le cycle 2 et 3.`}}</p>
          </div>
          <div class="col-sm-4 offset-md-1 py-4">
            <ul class="list-unstyled">
              <li><a @click="$emit('login')" class="text-white" v-show="!isConnected">Se connecter</a></li>
              <li><a @click="$emit('logout')" class="text-white" v-show="isConnected">Se déconnecter</a></li>
              <li><a @click="open(null, 'Edit')" class="text-white" v-show="isConnected">Proposer un problème</a></li>
              <li><a href="https://arnaud-lierville.github.io/" target="_blank" class="text-white">Autres outils Maths en classe !</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="navbar navbar-dark bg-dark shadow-sm">
      <div class="container">
        <a href="#" class="navbar-brand d-flex align-items-center">
          <img class="logo" :src="photoURL" v-show="photoURL">
          <strong>Problèmes en ligne</strong>
        </a>
        <div class="navbar-brand d-flex">
          <input class="form-control me-2 fix-margin-right" id="pbSearch" type="text" placeholder="numéro du problème" aria-label="Search" v-model="publicID" v-on:keyup.enter="$emit('openProblem', publicID)">
          <button class="btn btn-outline-info fix-margin-right" @click="$emit('openProblem', publicID)" :disabled="!publicID">Rechercher</button>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarHeader" aria-controls="navbarHeader" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
      </div>
    </div>
    
  </header>
</template>

<script>

import { open } from '../utils'

export default {
  name: 'NavBar',
  props: {
    user: Object
  },
  data() {
    return {
      publicID: null,
      allProblems: []
    }
  },
  firestore() {
    return { allProblems: this.db.collection('problems') }
  },
  methods: {
    open: open
  },
  computed: {
    totalDatabaseProblems() {
      console.log('totalDatabaseProblems')
      return this.allProblems.length
    },
    isConnected() {
      return this.user != null
    },
    photoURL() {
      let photoURL = null
      if (this.user) {photoURL = this.user.photoURL }
      return photoURL
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* bootstrap-vue fixing */
    .fix-margin-right {
        margin: 0px 8px 0px 0px;
    }
    .logo {
      width: 40px;
      margin-right: 16px;
      border-radius: 50%;
    }
</style>   